// @ts-nocheck
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isOrderSkusReadWrite } from 'models/user/selector';

/**
 * Redirect legacy /orders/by-sku route to the integrated tab.
 * The Order By SKU feature now lives as a tab inside /orders.
 */
const OrderBySkuRedirect = () => <Navigate to="/orders?selectedTab=bysku" replace />;

export default [
	{
		path: '/orders/by-sku',
		key: 'orderBySku',
		componentId: 'orderBySku',
		component: OrderBySkuRedirect,
		routes: [],
		title: 'Skulicity | Order By SKU',
		isEnabled: (state) => {
			return isOrderSkusReadWrite(state);
		},
		headerName: 'Order Management',
		exact: true,
		name: 'Order By SKU',
	},
];
